<div class="appo-appointment-highlight">
  <ng-container *ngIf="appoId && !(null | siExternalReference); else highlightContainer">
    <a routerLink="/appointment/{{appoId}}" [attr.aria-label]="'SI_APPOINTMENT_DETAIL' | translate">
      <ng-container *ngTemplateOutlet="highlightContainer"></ng-container>
    </a>
  </ng-container>
</div>
<ng-template #highlightContainer>
  <div class="appo-appointment-highlight_container"
       [ngClass]="{
         'appo-appointment-highlight_container_secondary': secondary,
         'pointer pasi-hover_scale': appoId && !(null | siExternalReference)
       }">
    <div class="row pasi-gap-v-12">
      <div class="col col-sm-6 order-0 mr-auto"
           [ngClass]="{'col-lg ': forceMobile}">
        <div class="d-flex mb-2">
          <ng-container *ngIf="startDate">
            <div>
              <div class="appo-appointment-highlight_container_title text-nowrap">
                {{startDate | amDateFormat: 'DD MMM' | uppercase}}
              </div>
              <div class="appo-appointment-highlight_container_year text-right">
                {{startDate | amDateFormat: 'YYYY'}}
              </div>
              <div class="appo-appointment-highlight_container_title text-nowrap d-flex justify-content-end">
                {{startDate | amDateFormat: 'HH:mm'}}{{'SI_HOUR_UNIT' | translate | lowercase}}
              </div>
            </div>
            <div class="appo-appointment-highlight_container_line"></div>
          </ng-container>
          <div class="appo-appointment-highlight_container_info flex-grow-1">
            <div class="appo-appointment-highlight_container_title">{{serviceName}}</div>
            <div *ngIf="professionalName" class="d-flex flex-grow-1 align-items-center">
              <i class="icosun-professional"></i>
              <span class="ml-2">{{professionalName}}</span>
            </div>
            <div *ngIf="centerName" class="d-flex flex-grow-1 align-items-center">
              <i class="{{appointmentAssistanceTypeIcons[assistanceTypeCode]}}"></i>
              <span class="ml-2">{{centerName}}</span>
            </div>
            <div *ngIf="multipleInsuranceAvailable && collectiveName" class="d-flex flex-grow-1 align-items-center">
              <i class="icosun-shield"></i>
              <span class="ml-2">{{collectiveName}}</span>
            </div>
            <div *ngIf="reasonName" class="d-flex flex-grow-1 align-items-center">
              <i class="icosun-prestacion font-big"></i>
              <span class="ml-2">{{reasonName}}</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="actions?.includes('SHOW_ARRIVAL_CONFIRMABLE') || actions?.includes('SHOW_WAITING_ROOM'); else attendanceConfirmation"
           class="col-12 col-sm col-lg-3 order-3 order-sm-1 my-auto"
           [ngClass]="{'col-lg-12 order-lg-3': forceMobile}">
        <si-appo-arrival-confirm-button [appoId]="appoId"
                                        [centerName]="centerName"
                                        [centerAddress]="centerAddress"
                                        [arrivalStartDate]="arrivalStartDate"
                                        [arrivalEndDate]="arrivalEndDate"
                                        [centerLatitude]="centerLatitude"
                                        [centerLongitude]="centerLongitude"
                                        [cardNumberSEOGA]="cardNumberSEOGA"
                                        [actions]="actions"
        ></si-appo-arrival-confirm-button>
      </div>
      <ng-template #attendanceConfirmation>
        <ng-container *siSecure="['appointment_management:attendance']">
          <div *ngIf="actions?.includes('SHOW_ATTENDANCE_CONFIRMABLE')"
               class="col-12 col-sm col-lg-3 order-3 order-sm-1 my-auto"
               [ngClass]="{'col-lg-12 order-lg-3': forceMobile}">
            <si-appo-attendance-confirm-button [appoId]="appoId"
                                               [serviceName]="serviceName"
                                               [startDate]="startDate"
                                               [assistanceTypeCode]="assistanceTypeCode"
                                               (appoAttendanceConfirmed)="onConfirmAttendance()"
            ></si-appo-attendance-confirm-button>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
</ng-template>
